import { type ChangeEvent, useCallback } from 'react';
import type { Lens } from '@hookform/lenses';
import { useController } from 'react-hook-form';
import { ComboboxInput, type ComboboxInputProps } from '@interxfi/design-system/components/input/combobox-input/combobox-input';

interface PropsWithLens<T extends string = string> extends Omit<ComboboxInputProps, 'name' | 'value'> {
  shouldUnregister?: boolean;
  lens: Lens<T>;
}

export function AppComboboxInputWithLens<T extends string = string>({ onChange, shouldUnregister, lens, ...props }: PropsWithLens<T>) {
  // TODO: remove any cast (lens library is new, doesn't support generics well yet)
  const { field, fieldState } = useController({ shouldUnregister, ...(lens.interop() as any) });
  const { onChange: fieldOnChange } = field;
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      fieldOnChange(e.target.value);
      onChange?.(e);
    },
    [fieldOnChange, onChange],
  );

  return (
    <ComboboxInput
      {...props}
      {...field}
      error={fieldState.error?.message}
      onChange={handleChange}
      touched={fieldState.isTouched}
      value={field.value || ''}
    />
  );
}
